 import HomeFilledIcon from '@mui/icons-material/HomeFilled';
 import GeocodingControl from '../../MapControls/GeocodingControl';
 
 const RenderHomeButtonnContent = ()=>
    (
       <div style={{ 
            backgroundColor: '#EEEFF0', 
            borderRadius: '8px', 
            padding: '32px',
            right: 0 ,
            width: 'calc(100% )',
            height:'calc(100% - 0px)',
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '32px' ,
              marginLeft:"56px",
              marginTop:"-15px"
            }}>
              <HomeFilledIcon style={{ 
                width: '24px', 
                height: '24px', 
                color: '#718096', 
                marginRight: '12px', 
                marginTop:"-5px" //Check this magic number 
              }} />
              <h1 style={{ 
                fontSize: '18px', 
                fontWeight: '600', 
                color: '#2d3748',
                fontFamily:"GoldbeckNextSemiBold2"
                  
              }}>
                Home Button
              </h1>
            </div>
              <p style={{ color: '#27292B',  marginLeft:"56px", fontFamily:"GoldbeckNextRegular", fontWeight:"600px", fontSize:"13px" }}>
                  Konfiguriere hier deinen Home Button in der Auswahl des Ortes. <br />
                  Wenn du auf den Button klickst, wirst du auf der Karte an den hier hinterlegten Ort zurückgebracht
              </p>

              <p style={{ color: '#27292B',  marginLeft:"56px", fontFamily:"GoldbeckNextSemiBold2", fontWeight:"600px", fontSize:"13px", marginTop:"50px"}}>
                  Standort des Home Buttons
              </p>
              <div style={{position:"relative", display:"grid", marginLeft:"30px", marginTop:"-30px"}}>
                <GeocodingControl mapRef={null } show={false}  />
                
              </div>
               <img src='\assets\homeTab.png' style={{marginTop:"120px", marginLeft:"56px", borderRadius:"12px"}}/> 
              
          </div>
      );

export default RenderHomeButtonnContent;
